var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "14px",
            "line-height": "40px",
            color: "#606266",
            "font-weight": "700",
          },
        },
        [_vm._v("日期(Data)")]
      ),
      _c("el-date-picker", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          clearable: false,
          "end-placeholder": "结束时间（Hora de fim）",
          "range-separator": "-",
          "start-placeholder": "开始时间（Hora de início）",
          type: "daterange",
          "value-format": "yyyy-MM-dd",
          size: "small",
        },
        on: { change: _vm.dateChange },
        model: {
          value: _vm.timeValue,
          callback: function ($$v) {
            _vm.timeValue = $$v
          },
          expression: "timeValue",
        },
      }),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "", size: "small" },
              on: { click: _vm.search },
            },
            [_vm._v("查询(Consultar)")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.exportAll },
            },
            [_vm._v("导出(Exportar)")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
            "max-height": "600",
            "summary-method": _vm.getSummaries,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              prop: "xuhao",
              label: "序号(No.)",
              align: "center",
              width: "60",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item, idx) {
            return _c("el-table-column", {
              key: idx,
              attrs: {
                align: "center",
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "lostCount" ||
                        item.prop === "damagedCount" ||
                        item.prop === "lossCount" ||
                        item.prop === "stolenCount"
                          ? _c("div", [
                              scope.row[item.prop]
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#1990ff",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toDetail(
                                            scope.row,
                                            item.prop
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row[item.prop]) + " "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("--")]),
                            ])
                          : _c(
                              "div",
                              {
                                style: {
                                  fontWeight:
                                    scope.row.isSummary && item.prop !== "xuhao"
                                      ? "bold"
                                      : "normal",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row[item.prop]
                                        ? "" + scope.row[item.prop]
                                        : "--"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }